import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { asPercent } from "@/lib/format";
import { useContrarianSignals } from "@/sdk/hooks/use-signals";

function signalTone(signal: string): string {
  if (signal.includes("BUY")) return "text-green-400";
  if (signal.includes("SELL")) return "text-red-400";
  return "text-white/60";
}

export function LiveFeed() {
  const { data, isLoading, isError, refetch } = useContrarianSignals(12);
  const signals = data?.opportunities ?? [];

  if (isLoading) {
    return <LoadingState text="Loading feed..." />;
  }

  // A failed fetch must never read as quiet markets — render the explicit
  // error state instead of the calm "no opportunities" copy.
  if (isError) {
    return (
      <Panel title="Live Signal Feed">
        <QueryErrorState what="live signal feed" onRetry={() => void refetch()} />
      </Panel>
    );
  }

  return (
    <Panel title="Live Signal Feed">
      <div className="max-h-80 space-y-1 overflow-y-auto">
        {signals.length === 0 ? (
          <p className="py-4 text-center text-sm text-white/40">No live opportunities right now.</p>
        ) : (
          signals.map((signal) => (
            <div
              key={`${signal.market_id}-${signal.token_id}`}
              className="flex items-center justify-between rounded px-2 py-1.5 text-xs hover:bg-white/5"
            >
              <span className="max-w-[220px] truncate font-mono text-white/70">
                {signal.question ?? signal.market_id}
              </span>
              <span className={`ml-2 font-bold ${signalTone(signal.signal)}`}>{signal.signal}</span>
              <span className="ml-2 text-white/30">{asPercent(signal.confidence)}</span>
            </div>
          ))
        )}
      </div>
    </Panel>
  );
}
